<template>
    <el-radio-group v-model="id" size="mini">
        <el-radio-button :label="item.id" v-for="item in list" :key="item.id">{{item.name}}</el-radio-button>
    </el-radio-group>
</template>

<script>
  export default {
    name: "dignose-tabs",
    props: {
      value: {
        type: String,
        default: '1'
      },
    },
    data() {
      return {
        id: '1',
        list: [
          {name: '发起的', id: '1'},
          {name: '收到的', id: '2'},
          {name: '已完成', id: '3'},
          {name: '已取消', id: '4'}
        ]
      }
    },
    watch: {
      id(newV) {
        this.$emit('input', newV);
      }
    }
  }
</script>

<style scoped>

</style>
